/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import Close from '@lt/components/icons-react/rebrand/XMark';
import { HOTEL_CARD_CLOSE_ICON } from 'src/components/HotelCard/constants';
import styles from './closeIcon.module.css';

type CloseIconProps = {
  onClick: () => void;
};

const CloseIcon: React.FC<CloseIconProps> = ({ onClick }) => (
  <div
    role="button"
    tabIndex={-1}
    onClick={onClick}
    data-testid={HOTEL_CARD_CLOSE_ICON}
    className={styles.iconWrapper}
  >
    <Close className={styles.icon} />
  </div>
);

export default CloseIcon;
